import React from 'react';
import { Divider, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectExpandedModsDialog, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { BillRateType } from './BillRateType';
import { FlatHour } from './FlatHour';
import { HourlyRates } from './HourlyRates/HourlyRates';
import { useWatch } from 'react-hook-form';
import { contractTypeId } from 'app/models/Placement/PlacementMods';
import { PerDiemRates } from '../../CommonComponents/PerDiemRates';
import { payRateModStyles } from '../PayRate/PayRateMod.styles';

export const BillRateMod = () => {
  const isExpanded = useSelector(selectExpandedModsDialog);
  const isModEdit = useSelector(selectIsEditMod);
  const contractType = useWatch({ name: contractTypeId });
  const { classes } = payRateModStyles({ isExpanded });

  return (
    <Grid>
      <BillRateType isExpanded={isExpanded} />
      {contractType === 1 ? (
        <>
          <FlatHour isExpanded={isExpanded} contractType={contractType} />
        </>
      ) : (
        <>
          <HourlyRates isExpanded={isExpanded} />
        </>
      )}
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <PerDiemRates isExpanded={isExpanded} isModEdit={isModEdit} />
    </Grid>
  );
};
